import { FluxType } from './flux/buildFlux';
import { Services } from './services';
import { AppServices } from './services/Service';

export default function CordovaServices(flux: FluxType): AppServices {
  console.log('deviceready');

  const services = new Services(flux);
  return services.build();
}
